/* SpinFlame v3 header: Info dropdown (hover + click + keyboard) and the mobile / tablet menu. */
(function () {
  if (window.__sv3HeaderInit) return;
  window.__sv3HeaderInit = true;

  var DESKTOP = window.matchMedia('(min-width: 1100px)');

  function setDropdown(item, open) {
    var btn = item.querySelector(':scope > button');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('[data-sv3-dropdown].is-open').forEach(function (item) {
      if (item !== except) setDropdown(item, false);
    });
  }

  function setDrawer(header, open) {
    var drawer = header.querySelector('[data-sv3-drawer]');
    var burger = header.querySelector('[data-sv3-burger]');
    if (!drawer || !burger) return;
    drawer.hidden = !open;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-sv3-dropdown] > button');
    if (toggle) {
      var item = toggle.parentElement;
      var willOpen = !item.classList.contains('is-open');
      closeAll(item);
      setDropdown(item, willOpen);
      return;
    }
    closeAll(null);

    var burger = event.target.closest('[data-sv3-burger]');
    if (burger) {
      var header = burger.closest('[data-sv3-header]');
      var drawer = header.querySelector('[data-sv3-drawer]');
      setDrawer(header, drawer.hidden);
      return;
    }

    var sub = event.target.closest('[data-sv3-drawer-toggle]');
    if (sub) {
      var list = document.getElementById(sub.getAttribute('aria-controls'));
      var expand = sub.getAttribute('aria-expanded') !== 'true';
      sub.setAttribute('aria-expanded', expand ? 'true' : 'false');
      if (list) list.hidden = !expand;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeAll(null);
    document.querySelectorAll('[data-sv3-header]').forEach(function (header) {
      var drawer = header.querySelector('[data-sv3-drawer]');
      if (drawer && !drawer.hidden) {
        setDrawer(header, false);
        var burger = header.querySelector('[data-sv3-burger]');
        if (burger) burger.focus();
      }
    });
  });

  document.addEventListener('focusout', function (event) {
    var item = event.target.closest && event.target.closest('[data-sv3-dropdown]');
    if (item && item.classList.contains('is-open') && event.relatedTarget && !item.contains(event.relatedTarget)) {
      setDropdown(item, false);
    }
  });

  DESKTOP.addEventListener('change', function (e) {
    if (e.matches) {
      document.querySelectorAll('[data-sv3-header]').forEach(function (header) { setDrawer(header, false); });
    }
  });
})();

if (!customElements.get('sv3-localization-form')) {
  customElements.define('sv3-localization-form', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const button = this.querySelector('button[aria-controls]');
      const panel = this.querySelector('.disclosure__list-wrapper');
      const form = this.querySelector('form');
      const field = this.querySelector('input[name="country_code"],input[name="language_code"]');
      if (!button || !panel || !form || !field) return;
      this.dataset.ready = 'true';
      const close = () => { panel.hidden = true; button.setAttribute('aria-expanded','false'); };
      button.addEventListener('click', () => {
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded',String(!panel.hidden));
      });
      this.addEventListener('keydown',event => {
        if (event.key === 'Escape') { close(); button.focus(); }
      });
      this.addEventListener('focusout',event => {
        if (!this.contains(event.relatedTarget)) close();
      });
      this.querySelectorAll('a[data-value]').forEach(link => link.addEventListener('click',event => {
        event.preventDefault();
        field.value = link.dataset.value;
        form.submit();
      }));
    }
  });
}

function sfInitCompatibility() {
  document.querySelectorAll('[data-sf-compat]').forEach(form => {
    if (form.dataset.ready) return;
    const section = form.closest('.shopify-section');
    const rows = Array.from(section.querySelectorAll('tr.compat-row'));
    const input = form.querySelector('input');
    const clear = form.querySelector('[data-compat-clear]');
    const status = form.querySelector('[role="status"]');
    if (!rows.length || !input || !clear || !status) return;
    form.dataset.ready = 'true';
    const filter = () => {
      const term = input.value.trim().toLocaleLowerCase();
      let count = 0;
      rows.forEach(row => {
        const matched = !term || row.textContent.toLocaleLowerCase().includes(term);
        row.hidden = !matched;
        if (matched) count += 1;
      });
      status.textContent = form.dataset.countLabel.replace('__COUNT__',String(count));
      clear.hidden = !term;
    };
    input.addEventListener('input',filter);
    form.addEventListener('submit',event => { event.preventDefault(); filter(); });
    clear.addEventListener('click',() => { input.value = ''; filter(); input.focus(); });
    filter();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',sfInitCompatibility);
else sfInitCompatibility();
document.addEventListener('shopify:section:load',sfInitCompatibility);
